import * as React from "react"
import { Box } from "@mui/material"
import { formatPercentage } from "@ui-seeker/utils"

import { ArrowBackground, NotAllowedBlock } from "@components"
import { sortByAbsoluteValue } from "../../sort"


export default function diffMyPriceColumn(label, myPrice) {
	return {
		name: 'diffMyPrice', label: label,
		options: {
			filter: false,
			customBodyRowRender: (value, { diffMyPricePrev, mainSiteProduct, ...dataRow }) => {
				const price = dataRow[myPrice]

				return <Box sx={{ textAlign: 'center' }}>
					{!!price && !mainSiteProduct && <ArrowBackground
						value={value}
						prev={diffMyPricePrev}
						backgroundColor={value > 0 ? 'success.light' : 'error.light'}
					>
						{formatPercentage(value, { decimals: 2 })}
					</ArrowBackground>}
					{!price && <NotAllowedBlock />}
				</Box>
			},
			sortCompare: sortByAbsoluteValue
		}
	}
}